<template>
  <div class="flex flex-wrap mb-2" :style="guideStep >= 75 && guideStep <= 78  ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <div class="flex">
        <div class="flex-none">
          <!-- <p class="shadowBox-title">即時表單</p> -->
          <span class="text-red-500">*</span>
          <span class="text-grap-700 align-middle">{{lang['views']['Form']['title']}}</span>
          <p class="ml-1.5 text-gray">{{lang['views']['Form']['title_info']}}</p>
        </div>
        <!-- <div v-show="!editPageType" class="flex-grow text-right">
          <button
            @click="newForm()"
            class="relative mr-2 button bg-blue"
          >
            <img
              class="mr-2 inline-block align-baseline"
              src="../assets/add.svg"
            />

            新表單
          </button>
          <button class="mr-2 button border-blue" :disabled="editType == 1" @click="activeImmediate(selectedItem, editType)">編輯</button>
          <button class="mr-2 button border-blue" :disabled="editType == 2" @click="activeImmediate(selectedItem, editType)">複製</button>
        </div>
        <div v-show="editPageType" class="flex-grow text-right">
          <button class="mr-2 button border-blue" @click="activeImmediate(selectedItem, editType)">瀏覽</button>
        </div> -->
        <div class="flex-grow text-right">
          <!-- 新手教學 -->
          <button
            @click="newForm()"
            class="relative mr-2 button bg-blue"
            :class="{ 'ring-4 border-blue-400': guideStep === 76 }"
          >
            <img
              class="mr-2 inline-block align-baseline"
              src="../assets/add.svg"
            />

            {{lang['views']['Form']['add_button_text']}}
          </button>
          <!-- 新手教學 -->
          <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 1" @click="activeImmediate(selectedItem, editType)">{{lang['views']['Form']['edit_button_text']}}</button>
          <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 2" @click="activeImmediate(selectedItem, editType)">{{lang['views']['Form']['copy_button_text']}}</button>
        </div>
      </div>

      <div class="px-4 py-2 mt-2 border-2 border-gray-ligth rounded-lg h-80">
        <div class="w-full h-full scrollbar-y">
          <div class="base-table">
            <template v-for="(item, value) in immediateList" :key="value.id">
              <div class="table-body">
                <div class="max-w-10">
                  <RadioButton name="immediate" :value="item.id" v-model="selectedItem" @click="changeSelectItem(item.id)" />
                </div>
                <div class="w-80">{{ item.title }}</div>
                <!-- 新手教學 -->
                <div class="max-w-28" :class="{ 'ring-4 border-blue-400': guideStep === 78 }"><span :class="[item.status]" style="white-space:nowrap;"></span></div>
                <div class="max-w-40">{{ item.date }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
    <!-- 新手教學 -->
    <div v-show="guideStep >= 75 && guideStep <= 78" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>

    <ModifyWindows v-model:show="showModal">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Form']['Dialog']['title']}}</span>
		<!-- 新手教學 -->
        <span class="p-input-icon-right" :class="{ 'ring-4 border-blue-400': formGuideStep === 801 }">
          <input
            ref="titleText"
            class="p-inputtext p-component w-auto underline-box"
            type="text" v-model="formName"
            :placeholder="lang['views']['Form']['title_placeholder']"
          />
          <i
            @click="$refs.titleText.focus()"
            class="pi pi-pencil cursor-pointer"
          ></i>
        </span>
      </template>

      <template v-slot:content>
        <div class="relative flex h-full">
          <div class="flex-grow">
          	<!-- 新手教學 -->
            <ShadowBox class="mx-auto h-full" :class="{ 'ring-4 border-blue-400': formGuideStep === 802 }">
              <!-- 新手教學 -->
              <div class="menu relative pr-2 scrollbar-y w-full h-full" ref="introContent">
                <ul>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 804 }">
                    <div
                      @click="menuActive = 1"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 1 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_1']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 1 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_1']['title_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form1.type"
                              value="0"
                              class="mt-6"
                            />
                            {{lang['views']['Form']['Dialog']['block_1']['radio_1']}}
                          </label>
                          <br />
                          <p class="ml-6 mb-6 text-gray">{{lang['views']['Form']['Dialog']['block_1']['radio_1_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form1.type"
                              value="1"
                            />
                            {{lang['views']['Form']['Dialog']['block_1']['radio_2']}}
                          </label>
                          <br />
                          <p class="ml-6 text-gray">{{lang['views']['Form']['Dialog']['block_1']['radio_2_info']}}</p>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 805 }">
                    <div
                      @click="menuActive = 2"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 2 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_2']['title']}}
                    </div>
                    <!-- 新手教學 -->
                    <ul :class="{ active: menuActive == 2 }" class="sub" >
                      <li>
                        <div>
                          <div class="flex">
                            <p class="flex-grow">
                              {{lang['views']['Form']['Dialog']['block_2']['title_info']}}
                            </p>
                            <div class="flex-none font-semibold">
                              <InputSwitch
                                v-model="formData.form2.isOpen"
                                class="mr-2"
                              />
                              <span class="align-text-bottom">{{lang['views']['Form']['Dialog']['block_2']['switch_text']}}</span>
                            </div>
                          </div>

                          <div v-show="formData.form2.isOpen">
                            <!-- <FormInput
                              v-model="formData.form2.title"
                              :isError="true"
                              title="標題"
                              formClass="mt-6"
                              placeholder="請輸入標題"
                              error="Title is required."
                            /> -->
                            <FormInput
                              v-model="formData.form2.title"
                              :title="lang['views']['Form']['Dialog']['block_2']['title_text']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_2']['title_placeholder']"
                            />

                            <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_2']['use_image']}}</p>
                            <p>
                              {{lang['views']['Form']['Dialog']['block_2']['use_image_info']}}
                            </p>

                            <p class="mt-6 font-semibold">說明</p>
                            <p>
                              使用廣告中的圖像(你廣告的圖像會和說明卡一起顯示)
                            </p>

                            <p class="mt-6">
                              <!-- 新手教學 -->
                              <label class="mr-4" :class="{ 'ring-4 border-blue-400': formGuideStep === 806 }">
                                <RadioButton
                                  v-model="formData.form2.introductionType"
                                  value="0"
                                />
                                {{lang['views']['Form']['Dialog']['block_2']['radio_1']}}
                              </label>

                              <!-- 新手教學 -->
                              <label :class="{ 'ring-4 border-blue-400': formGuideStep === 807 }">
                                <RadioButton
                                  v-model="formData.form2.introductionType"
                                  value="1"
                                />
                                {{lang['views']['Form']['Dialog']['block_2']['radio_2']}}
                              </label>
                            </p>

                            <template
                              v-if="formData.form2.introductionType === '0'"
                            >
                              <!-- <FormTextarea
                                v-model="formData.form2.introduction"
                                :isError="true"
                                formClass="mt-2"
                                placeholder="輸入文字，向用戶介紹你的商品或服務"
                                rows="5"
                                error="Introduction is required."
                              /> -->
                              <FormTextarea
                                v-model="formData.form2.introduction"
                                formClass="mt-2"
                                :placeholder="lang['views']['Form']['Dialog']['block_2']['radio_1_placeholder']"
                                rows="5"
                              />
                            </template>
                            <template v-else>
                              <template
                                v-for="(item, i) in formData.form2
                                  .introductionItem"
                                :key="i"
                              >
                                <FormInput
                                  v-model="formData.form2.introductionItem[i]"
                                  formClass="mt-2"
                                  :placeholder="lang['views']['Form']['Dialog']['block_2']['radio_2_placeholder']"
                                />
                              </template>
                            </template>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 808 }">
                    <div
                      @click="menuActive = 3"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 3 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_3']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 3 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_3']['title_info']}}</p>

                          <draggable
                            v-show="formData.form3.single?.length"
                            v-model="formData.form3.single"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="id"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div
                                  class="flex-grow mr-2 border border-gray-300 rounded-md"
                                >
                                  <div class="flex h-10">
                                  	<!-- 新手教學 -->
                                    <img
                                      :class="{ 'ring-4 border-blue-400': formGuideStep === 814 }"
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../assets/move.svg"
                                    />
                                    <div class="flex-grow p-2">
                                      <p v-show="element.isOpen" class="pb-2">
                                        {{lang['views']['Form']['Dialog']['block_3']['single_question']}}
                                      </p>
                                      <!-- 新手教學 -->
                                      <input
                                        v-model="element.text"
                                        :class="{
                                          'px-4 py-2 h-10 border border-gray-400':
                                            element.isOpen,
                                          'ring-4 border-blue-400': formGuideStep === 810
                                        }"
                                        class="rounded-md w-full"
                                        type="text"
                                        :placeholder="lang['views']['Form']['Dialog']['block_3']['single_question_placeholder']"
                                      />
                                    </div>

                                    <div
                                      v-if="!element.isOpen"
                                      @click="element.isOpen = !element.isOpen"
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                        cursor-pointer
                                      "
                                    >
                                      {{ element.type.name }}
                                    </div>
                                    <template v-else>
                                      <div
                                        @click="element.isOpen = !element.isOpen"
                                        class="p-2 text-blue-light cursor-pointer"
                                      >
                                        {{lang['views']['Form']['Dialog']['block_3']['toggle_button_text']}}
                                        <i class="pi pi-caret-up"></i>
                                      </div>
                                    </template>
                                  </div>

								  <!-- 新手教學 -->
                                  <div v-show="element.isOpen" class="mt-16" :class="{ 'ring-4 border-blue-400': formGuideStep === 811 }">
                                    <p class="ml-8">{{lang['views']['Form']['Dialog']['block_3']['single_question_answer']}}</p>
                                    <!-- <draggable
                                      v-show="element.answer?.length"
                                      v-model="element.answer"
                                      @start="drag = true"
                                      @end="drag = false"
                                      item-key="i"
                                    >
                                      <template #item="{ subElement, i }">
                                        <div
                                          class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                        >
                                          <img
                                            class="flex-none m-3 h-4 cursor-move"
                                            src="../assets/move.svg"
                                          />
                                          <p class="flex-grow py-2">
                                            {{ subElement.text }}
                                          </p>
                                          <span
                                            @click="element.answer.splice(i, 1)"
                                            class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                          ></span>
                                        </div>
                                      </template>
                                    </draggable> -->

                                    <!-- <div
                                      v-for="(item, i) in element.answer"
                                      :key="i"
                                      class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                    >
                                      <img
                                        class="flex-none m-3 h-4 cursor-move"
                                        src="../assets/move.svg"
                                      />
                                      <p class="flex-grow py-2">
                                        {{ item.text }}
                                      </p>
                                      <span
                                        @click="element.answer.splice(i, 1)"
                                        class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                      ></span>
                                    </div> -->

                                    <draggable
                                      v-show="element.answer?.length"
                                      v-model="element.answer"
                                      @start="drag = true"
                                      @end="drag = false"
                                      item-key="i"
                                    >
                                      <template #item="{ element: element_sub, index }">
                                      	<!-- 新手教學 -->
                                        <div
                                          class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                          :class="{ 'ring-4 border-blue-400': formGuideStep === 812 }"
                                        >
                                          <img
                                            class="flex-none m-3 h-4 cursor-move"
                                            src="../assets/move.svg"
                                          />
                                          <p class="flex-grow py-2">
                                            {{ element_sub.text }}
                                          </p>
                                          <span
                                            @click="
                                              removeForm3SingleAnswer(
                                                element.id,
                                                index
                                              )
                                            "
                                            class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                          ></span>
                                        </div>
                                      </template>
                                    </draggable>

                                    <div class="flex my-2">
                                      <div class="flex-grow pl-8">
                                        <input
                                          v-model="element.answerText"
                                          class="flex-grow px-4 py-2 w-full border border-gray-400 rounded-md"
                                          type="text"
                                          :placeholder="lang['views']['Form']['Dialog']['block_3']['single_question_answer_placeholder']"
                                        />
                                      </div>
                                      <div class="flex-none">
                                        <button
                                          @click="setForm3Answer(element)"
                                          class="mx-2 button bg-blue"
                                        >
                                          <img
                                            class="mr-2 inline-block align-baseline"
                                            src="../assets/add.svg"
                                          />
                                          {{lang['views']['Form']['Dialog']['block_3']['add_ingle_question_item']}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <!-- 新手教學 -->
                                  <div
                                    @click="removeForm3Single(element.id)"
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                    :class="{ 'ring-4 border-blue-400': formGuideStep === 813 }"
                                  >
                                    <img src="../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <p class="mt-6">{{lang['views']['Form']['Dialog']['block_3']['other_question']}}</p>
                          <draggable
                            v-show="formData.form3.other?.length"
                            v-model="formData.form3.other"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="id"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div
                                  :class="{
                                    'h-24':
                                      element.isOpen &&
                                      element.type.name == lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                  }"
                                  class="flex-grow mr-2 border border-gray-300 rounded-md"
                                >
                                  <div class="flex h-10">
                                    <img
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../assets/move.svg"
                                    />

                                    <div class="flex-grow p-2">
                                      <p v-show="element.isOpen" class="pb-2">
                                        {{
                                          element.type.name == lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                            ? lang['views']['Form']['Dialog']['block_3']['short_answer_questions']
                                            : lang['views']['Form']['Dialog']['block_3']['reserve_questions']
                                        }}
                                      </p>
                                      <input
                                        v-model="element.text"
                                        :class="{
                                          'px-4 py-2 h-10 border border-gray-400':
                                            element.isOpen
                                        }"
                                        class="rounded-md w-full"
                                        type="text"
                                        :placeholder="lang['views']['Form']['Dialog']['block_3']['short_answer_questions_placeholder']"
                                      />
                                    </div>

                                    <div
                                      v-if="!element.isOpen"
                                      @click="element.isOpen = !element.isOpen"
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                        cursor-pointer
                                      "
                                    >
                                      {{ element.type.name }}
                                    </div>
                                    <template v-else>
                                      <div
                                        @click="element.isOpen = !element.isOpen"
                                        class="p-2 text-blue-light cursor-pointer"
                                      >
                                        {{lang['views']['Form']['Dialog']['block_3']['toggle_button_text']}}
                                        <i class="pi pi-caret-up"></i>
                                      </div>
                                    </template>
                                  </div>

                                  <div
                                    v-show="
                                      element.isOpen &&
                                        element.type.name != lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                    "
                                    class="p-8 pr-20 mt-8"
                                  >
                                    <p class="ml-1">{{lang['views']['Form']['Dialog']['block_3']['reserve_questions_placeholder']}}</p>

                                    <input
                                      v-model="element.confirm"
                                      class="flex-grow px-4 py-2 m-1 w-full border border-gray-400 rounded-md"
                                      type="text"
                                      :placeholder="lang['views']['Form']['Dialog']['block_3']['reserve_questions_placeholder']"
                                    />

                                    <p class="m-1 mt-4">{{lang['views']['Form']['Dialog']['block_3']['reserve_questions_info_1']}}</p>
                                    <p class="m-1 text-sm text-gray-400">
                                      {{lang['views']['Form']['Dialog']['block_3']['reserve_questions_info_2']}}
                                    </p>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <div
                                    @click="removeForm3Other(element.id)"
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <!-- 新手教學 -->
                          <Dropdown
                            :class="{ 'ring-4 border-blue-400': formGuideStep === 809 || formGuideStep === 815 }"
                            v-model="formData.form3.type"
                            @change="form3TypeChange"
                            :options="form3Options"
                            optionLabel="name"
                            class="mt-2"
                          >
                            <template #value="">
                              <div class="country-item">
                                <i class="pi pi-plus mr-2"></i>
                                <span>{{lang['views']['Form']['Dialog']['block_3']['setting_questions']}}</span>
                              </div>
                            </template></Dropdown
                          >
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 816 }">
                    <div
                      @click="menuActive = 4"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 4 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_4']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 4 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_4']['title_info']}}</p>

                          <FormInput
                            v-model="formData.form4.instruction"
                            :title="lang['views']['Form']['Dialog']['block_4']['input_title']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_4']['input_title_placeholder']"
                            error="Title is required."
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_4']['add_info_title_text']}}</p>

                          <draggable
                            v-show="formData.form4.dataType?.length"
                            v-model="formData.form4.dataType"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="code"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div class="flex-grow">
                                  <div
                                    class="
                                      flex
                                      mr-2
                                      h-10
                                      border border-gray-300
                                      rounded-md
                                    "
                                  >
                                    <img
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../assets/move.svg"
                                    />
                                    <input
                                      v-model="element.text"
                                      class="flex-grow"
                                      type="text"
                                      :placeholder="lang['views']['Form']['Dialog']['block_4']['add_info_title_text_placeholder']"
                                    />
                                    <div
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                      "
                                    >
                                      {{ element.type.typeName }}
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <div
                                    @click="
                                      removeForm4Datatype(element.type.code)
                                    "
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <div class="mt-2">
                          	<!-- 新手教學 -->
                            <CascadeSelect
                              :class="{ 'ring-4 border-blue-400': formGuideStep === 817 || formGuideStep === 818 }"
                              v-model="formData.form4.type"
                              @change="form4TypeChange"
                              :options="formData.form4.countries"
                              optionLabel="name"
                              optionGroupLabel="name"
                              :optionGroupChildren="['sub']"
                              style="min-width: 14rem"
                              :placeholder="lang['views']['Form']['Dialog']['block_4']['cascade_select_placeholder']"
                            >
                              <template #value="">
                                <div class="country-item">
                                  <i class="pi pi-plus mr-2"></i>
                                  <span>{{lang['views']['Form']['Dialog']['block_4']['cascade_select_placeholder']}}</span>
                                </div>
                              </template>

                              <template #option="slotProps">
                                <div
                                  :class="{
                                    'absolute top-0 left-0 bg-gray-100 w-full h-full cursor-not-allowed':
                                      formData.form4.isCountries.indexOf(
                                        slotProps.option.code
                                      ) > -1
                                  }"
                                ></div>
                                <span
                                  :class="{
                                    'cursor-not-allowed':
                                      formData.form4.isCountries.indexOf(
                                        slotProps.option.code
                                      ) > -1
                                  }"
                                  class="z-10"
                                  >{{ slotProps.option.name }}</span
                                >
                              </template>
                            </CascadeSelect>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 819 }">
                    <div
                      @click="menuActive = 5"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 5 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_5']['title']}}
                    </div>
                    <ul
                      :class="{
                        active: menuActive == 5,
                        'max-h-initial':
                          menuActive == 5 && formData.form5.isOpen
                      }"
                      class="sub"
                    >
                      <li>
                        <div>
                          <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_5']['item_title_1']}}</p>
                          <p>
                            {{lang['views']['Form']['Dialog']['block_5']['item_title_1_info']}}
                          </p>

                          <FormInput
                            v-model="formData.form5.url"
                            :title="lang['views']['Form']['Dialog']['block_5']['input_title_1']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_5']['input_title_1_placeholder']"
                            error="is required."
                          />

                          <FormInput
                            v-model="formData.form5.urlText"
                            :title="lang['views']['Form']['Dialog']['block_5']['input_title_2']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_5']['input_title_2_placeholder']"
                            error="is required."
                          />

                          <hr class="mt-6" />

                          <div class="flex mt-6">
                            <div class="flex-grow">
                              <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_5']['item_title_2']}}</p>
                            </div>
                            <div class="flex-none">
                              <InputSwitch
                                v-model="formData.form5.isOpen"
                                class="mr-2"
                              />
                              <span class="align-text-bottom"
                                >{{lang['views']['Form']['Dialog']['block_5']['switch_text']}}</span
                              >
                            </div>
                          </div>

                          <p>
                            {{lang['views']['Form']['Dialog']['block_5']['item_title_2_info']}}
                          </p>

                          <div v-show="formData.form5.isOpen">
                            <FormInput
                              v-model="formData.form5.title"
                              :title="lang['views']['Form']['Dialog']['block_5']['description_title']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_5']['description_title_placeholder']"
                              error="is required."
                            />

                            <FormInput
                              v-model="formData.form5.content"
                              :title="lang['views']['Form']['Dialog']['block_5']['description_text']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_5']['description_text_placeholder']"
                              error="is required."
                            />

                            <template
                              v-for="(item, i) in formData.form5.agree"
                              :key="i"
                            >
                              <div class="flex">
                                <div class="flex-grow pr-2">
                                  <FormInput
                                    v-model="item.content"
                                    :title="lang['views']['Form']['Dialog']['block_5']['condition_title'] + (i + 1)"
                                    formClass="mt-6"
                                    :placeholder="lang['views']['Form']['Dialog']['block_5']['condition_text']"
                                    error="is required."
                                  />
                                </div>

                                <div class="flex-none">
                                  <div
                                    @click="formData.form5.agree.splice(i, 1)"
                                    class="
                                      p-2
                                      mt-12
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="/img/clear.5937fadd.svg" />
                                  </div>
                                </div>
                              </div>

                              <Checkbox v-model="item.isAgree" :binary="true" />
                              <label @click="item.isAgree = !item.isAgree">
                                {{lang['views']['Form']['Dialog']['block_5']['condition_checkbox_text']}}
                              </label>
                            </template>

                            <div class="mt-2">
                              <button
                                @click="setForm5Agree"
                                class="relative button border-blue"
                              >
                                <img
                                  class="mr-2 inline-block align-baseline"
                                  src="../assets/add_blue.svg"
                                />
                                {{lang['views']['Form']['Dialog']['block_5']['add_condition_text']}}
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 820 }">
                    <div
                      @click="menuActive = 6"
                      class="py-2 pl-4 text-xl font-semibold"
                      :class="{ 'not-required': selectLang == 'zh-TW', 'not-required_zh_cn': selectLang == 'zh-CN', 'not-required_en_us': selectLang == 'en-US' }"
                    >
                      <img
                        :class="{ active: menuActive == 6 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_6']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 6 }" class="sub">
                      <li>
                        <div>
                          <p>
                            {{lang['views']['Form']['Dialog']['block_6']['title_info']}}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 821 }">
                    <div
                      @click="menuActive = 7"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 7 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_7']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 7 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_7']['title_info']}}</p>

                          <FormInput
                            v-model="formData.form7.title"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_1']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_1_placeholder']"
                            error="is required."
                          />

                          <p v-show="false">你可以自訂潛在顧客提交表單後看到的畫面</p>

                          <!-- <FormTextarea
                            v-model="formData.form7.main"
                            :isError="false"
                            title="主要文字"
                            formClass="mt-6"
                            placeholder="請輸入主要文字"
                            rows="5"
                            error="Introduction is required."
                          /> -->
                          <FormTextarea
                            v-model="formData.form7.main"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_2']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_2_placeholder']"
                            rows="5"
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_7']['item_title_3']}}</p>
                          <Dropdown
                            id="dropdownButton"
                            v-model="formData.form7.web"
                            :options="[{ name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['view_website'], code: 'VIEW_WEBSITE' }, { name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['downliad'], code: 'DOWNLOAD' }, { name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['call_business'], code: 'CALL_BUSINESS' }]"
                            optionLabel="name"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_placeholder']"
                          />

                          <div v-if="formData.form7.web.code == 'CALL_BUSINESS'">
                            <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['title']}}</p>
                            <div class="flex overflow-hidden text-white">
                              <div class="w-1/4">
                                <Dropdown
                                  id="dropdown"
                                  class="w-full"
                                  v-model="formData.form7.countryCode"
                                  :options="countryCodeListBase"
                                  optionLabel="name"
                                  :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['country_code_placeholder']"
                                />
                              </div>
                              <div class="w-3/4">
                                <FormInput
                                  v-model="formData.form7.business_phone_number"
                                  :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['phone_placeholder']"
                                />
                              </div>
                            </div>
                          </div>

                          <!-- <FormInput
                            v-model="formData.form7.btntext"
                            title="按鈕文字"
                            formClass="mt-6"
                            placeholder="請輸入按鈕文字"
                            error="is required."
                          /> -->
                          <FormInput
                            v-model="formData.form7.btntext"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_4']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_4_placeholder']"
                          />

                          <!-- <FormInput
                            v-model="formData.form7.url"
                            title="網站連結"
                            formClass="mt-6"
                            placeholder="請輸入網站連結"
                            error="is required."
                          /> -->
                          <FormInput
                            v-model="formData.form7.url"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_5']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_5_placeholder']"
                          />
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 822 }">
                    <div
                      @click="menuActive = 8"
                      class="py-2 pl-4 text-xl font-semibold"
                      :class="{ 'not-required': selectLang == 'zh-TW', 'not-required_zh_cn': selectLang == 'zh-CN', 'not-required_en_us': selectLang == 'en-US' }"
                    >
                      <img
                        :class="{ active: menuActive == 8 }"
                        src="../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_8']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 8 }" class="sub">
                      <li>
                        <div>
                          <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_8']['item_title_1']}}</p>
                          <Dropdown
                            id="dropdownLang"
                            v-model="formData.form8.lang"
                            :options="[{ name: 'English(US)', code: 'en_US' }, { name: 'English(UK)', code: 'en_GB' }, { name: '中文 (台灣)', code: 'zh_TW' }, { name: '中文 (香港)', code: 'zh_HK' }, { name: '中文 (简体)', code: 'zh_CN' }]"
                            optionLabel="name"
                            :placeholder="lang['views']['Form']['Dialog']['block_8']['item_title_1_placeholder']"
                            @change="test()"
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_8']['item_title_2']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form8.shareType"
                              value="1"
                              class="mt-6"
                            />
                            {{lang['views']['Form']['Dialog']['block_8']['radio_1_title']}}
                          </label>
                          <br />
                          <p class="ml-6 mb-6 text-gray">{{lang['views']['Form']['Dialog']['block_8']['radio_1_title_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form8.shareType"
                              value="0"
                            />
                            {{lang['views']['Form']['Dialog']['block_8']['radio_2_title']}}
                          </label>
                          <br />
                          <p class="ml-6 text-gray">{{lang['views']['Form']['Dialog']['block_8']['radio_2_title_info']}}</p>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </ShadowBox>
          </div>
          <!-- 新手教學 -->
          <div class="flex-none" :class="{ 'ring-4 border-blue-400': formGuideStep === 803 }">
            <ShadowBox :padding="false" class="w-80 h-full">
              <div class="flex flex-col h-full">
                <p class="px-4 py-2 font-semibold border-b">{{lang['views']['Form']['Dialog']['preview']['title']}}</p>
                <div class="flex px-4 py-2 font-semibold border-b">
                  <p class="flex-grow">
                    {{ previewTitle }}
                  </p>
                  <div class="flex-none pr-1">{{ preview }}/4</div>
                  <div class="flex flex-none py-2 bg-gray rounded-full">
                    <div
                      @click="prev"
                      class="flex-none w-6 h-full cursor-pointer"
                    >
                      <svg
                        width="7"
                        height="9"
                        viewBox="0 0 7 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-auto"
                      >
                        <path
                          d="M5.59122 0.549561L1.85352 4.15393L5.59122 8.35903"
                          stroke="white"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <div
                      @click="next"
                      class="flex-none w-6 h-full cursor-pointer"
                    >
                      <svg
                        width="7"
                        height="9"
                        viewBox="0 0 7 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-auto"
                      >
                        <path
                          d="M0.785829 8.35962L5.14648 4.75525L0.785829 0.550147"
                          stroke="white"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="px-4 flex-grow overflow-hidden border-b">
                  <div
                    class="
                      relative
                      flex flex-col
                      h-full
                      scrollbar-y
                      bg-gray-light
                    "
                  >
                    <div class="relative h-40 bg-navy">
                      <div
                        class="
                          absolute
                          w-6
                          h-6
                          top-2
                          left-2
                          bg-black-50
                          rounded-full
                          cursor-pointer
                        "
                      >
                        <i class="ml-1 pi pi-chevron-left text-white"></i>
                      </div>
                      <div
                        class="
                          absolute
                          w-6
                          h-6
                          top-2
                          right-2
                          bg-black-50
                          rounded-full
                          cursor-pointer
                        "
                      >
                        <i class="ml-1 pi pi-times text-white"></i>
                      </div>
                    </div>
                    <div class="flex-grow min-h-56 bg-gray-light"></div>

                    <div class="absolute px-2 top-20 w-full">
                      <div
                        v-show="formData.form2.isOpen"
                        class="
                          absolute
                          ml-4
                          -top-3
                          left-24
                          w-14
                          h-14
                          border border-white
                          bg-gray-900
                          rounded-full
                          z-10
                        "
                      ></div>
                      <ShadowBox
                        v-show="formData.form2.isOpen"
                        :active="menuActive == 2"
                        :class="{ focus: formData.focus == 'form2_title' }"
                        class="pb-0 w-full"
                      >
                        <p class="mt-4 text-sm text-center text-gray">
                          {{lang['views']['Form']['Dialog']['preview']['form2_label']}}
                        </p>
                        <p class="mt-4 text-center font-semibold">
                          {{
                            formData.form2.title ? formData.form2.title : lang['views']['Form']['Dialog']['preview']['form2_title']
                          }}
                        </p>

                        <template v-if="formData.form2.introductionType == 0">
                          <p class="mt-4 text-sm">
                            {{
                              formData.form2.introduction
                                ? formData.form2.introduction
                                : lang['views']['Form']['Dialog']['preview']['form2_introduction']
                            }}
                          </p>
                        </template>
                        <template
                          v-else-if="formData.form2.introductionType == 1"
                        >
                          <ul class="list-disc">
                            <template
                              v-for="(item, i) in formData.form2
                                .introductionItem"
                              :key="i"
                            >
                              <li v-show="item != ''">{{ item }}</li>
                            </template>
                          </ul>
                        </template>
                      </ShadowBox>

                      <ShadowBox
                        v-for="(item, i) in formData.form3.single"
                        :key="i"
                        :active="menuActive == 3"
                        class="pb-0 w-full"
                      >
                        <p class="font-semibold">
                          {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_01_title'] }}
                        </p>

                        <template v-for="(a, j) in item.answer" :key="j">
                          <p
                            class="
                              p-2
                              mx-2
                              mt-1
                              bg-gray-300
                              rounded-full
                              text-center
                              font-semibold
                            "
                          >
                            {{ a.text ? a.text : lang['views']['Form']['Dialog']['preview']['form3_code_01_text'] }}
                          </p>
                        </template>
                      </ShadowBox>

                      <template
                        v-for="(item, i) in formData.form3.other"
                        :key="i"
                      >
                        <ShadowBox
                          v-show="item.type.code == '02'"
                          :active="menuActive == 3"
                          class="pb-0 w-full"
                        >
                          <p class="font-semibold">
                            {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_02_title'] }}
                          </p>

                          <p class="mt-4 text-gray-300 border-b text-sm">
                            {{lang['views']['Form']['Dialog']['preview']['form3_code_02_text']}}
                          </p>
                        </ShadowBox>
                      </template>

                      <template
                        v-for="(item, i) in formData.form3.other"
                        :key="i"
                      >
                        <ShadowBox
                          v-show="item.type.code == '03'"
                          class="pb-0 w-full"
                        >
                          <p class="font-semibold">
                            {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_03_title'] }}
                          </p>

                          <p class="mt-4 text-gray-300 border-b text-sm">
                            <span class="mr-4">{{lang['views']['Form']['Dialog']['preview']['form3_code_03_date_text']}}</span>
                            <span class="mr-4">{{lang['views']['Form']['Dialog']['preview']['form3_code_03_time_text']}}</span>
                          </p>
                        </ShadowBox>
                      </template>

                      <ShadowBox
                        v-show="formData.form4.dataType?.length"
                        :active="menuActive == 4"
                      >
                        <p class="flex font-semibold">
                          {{lang['views']['Form']['Dialog']['preview']['form4_dataType_title']}}
                          <img
                            @click="formData.form4.isOpenInstruction = true"
                            class="ml-2 w-4 cursor-pointer"
                            src="../assets/info.svg"
                            alt=""
                          />
                        </p>

                        <!-- <p class="mt-4 text-sm text-gray-400">全名</p>
                        <p
                          class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                        >
                          請輸入答案
                        </p>
                        <p class="mt-2 text-sm text-gray-400">性別</p>
                        <p
                          class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                        >
                          請輸入答案
                        </p> -->

                        <template
                          v-for="(item, i) in formData.form4.dataType"
                          :key="i"
                        >
                          <p class="mt-4 text-sm text-gray-400">
                            {{ item.text }}
                          </p>
                          <p
                            class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                          >
                            {{lang['views']['Form']['Dialog']['preview']['form4_dataType_text']}}
                          </p>
                        </template>
                      </ShadowBox>

                      <ShadowBox
                        v-show="formData.form1.type == '1'"
                        :active="menuActive == 1 || menuActive == 6"
                      >
                        <p class="font-semibold">{{lang['views']['Form']['Dialog']['preview']['form1_type_title']}}</p>
                        <p class="mt-4 text-sm text-gray-300">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_1']}}</p>
                        <p class="mt-2 text-sm">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_2']}}</p>
                        <p class="mt-2 text-sm">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_3']}}</p>
                      </ShadowBox>

                      <ShadowBox
                        v-show="
                          formData.form5.isOpen ||
                            formData.form5.url ||
                            formData.form5.urlText
                        "
                      >
                        <p class="mb-4 font-semibold">
                          {{
                            formData.form5.title
                              ? formData.form5.title
                              : formData.form5.isOpen
                              ? lang['views']['Form']['Dialog']['preview']['form5_title_1']
                              : lang['views']['Form']['Dialog']['preview']['form5_title_2']
                          }}
                        </p>

                        <template
                          v-for="(item, i) in formData.form5.agree"
                          :key="i"
                        >
                          <div v-show="formData.form5.isOpen">
                            <Checkbox :binary="true" class="mr-1" />
                            <label>
                              {{ item.content ? item.content : lang['views']['Form']['Dialog']['preview']['form5_agree_title'] }}
                              <span
                                v-show="item.isAgree"
                                class="ml-2 text-gray-300"
                                >{{lang['views']['Form']['Dialog']['preview']['form5_agree_info']}}</span
                              >
                            </label>
                          </div>
                        </template>

                        <hr
                          v-show="
                            formData.form5.agree?.length && formData.form5.isOpen
                          "
                          class="my-4"
                        />

                        <p class="text-sm text-gray-400">
                          {{
                            formData.form5.content && formData.form5.isOpen
                              ? formData.form5.content
                              : lang['views']['Form']['Dialog']['preview']['form5_content']
                          }}
                          <a :href="formData.form5.url" class="underline">{{
                            formData.form5.urlText
                              ? formData.form5.urlText
                              : lang['views']['Form']['Dialog']['preview']['form5_urlText']
                          }}</a>
                        </p>
                      </ShadowBox>

                      <ShadowBox
                        v-show="formData.form7.title || formData.form7.main"
                        :active="menuActive == 7"
                        :class="{ focus: formData.focus == 'form2_title' }"
                        :overflowHidden="false"
                        class="pb-0 mt-8 w-full"
                      >
                        <div
                          class="
                            absolute
                            ml-0
                            -top-6
                            left-24
                            w-14
                            h-14
                            border border-white
                            bg-gray-900
                            rounded-full
                            z-10
                          "
                        ></div>
                        <p class="mt-4 text-sm text-center text-gray">
                          {{lang['views']['Form']['Dialog']['preview']['form2_label']}}
                        </p>
                        <p class="mt-4 text-2xl text-center font-semibold">
                          {{
                            formData.form7.title ? formData.form7.title : lang['views']['Form']['Dialog']['preview']['form7_title']
                          }}
                        </p>
                        <p class="mt-2 text-center font-semibold">
                          {{
                            formData.form7.main
                              ? formData.form7.main
                              : lang['views']['Form']['Dialog']['preview']['form7_main']
                          }}
                        </p>

                        <hr class="my-4" />

                        <p class="text-sm text-center text-gray-400">
                          {{lang['views']['Form']['Dialog']['preview']['form7_main_info']}}
                        </p>
                      </ShadowBox>
                    </div>

                    <div
                      v-show="formData.form4.isOpenInstruction"
                      class="absolute w-full h-full bg-gray-800 opacity-50 z-20"
                    ></div>
                    <div
                      v-show="formData.form4.isOpenInstruction"
                      class="w-full hor-ver-center z-50"
                    >
                      <ShadowBox :padding="false">
                        <div
                          class="relative p-2 w-full font-semibold text-center border-b"
                        >
                          <span
                            @click="formData.form4.isOpenInstruction = false"
                            class=" absolute top-3 left-2 pi pi-times cursor-pointer"
                          ></span>
                          {{lang['views']['Form']['Dialog']['preview']['form4_isOpenInstruction']}}
                        </div>

                        <p class="p-4 text-sm text-gray-400">
                          {{
                            formData.form4.instruction
                              ? formData.form4.instruction
                              : lang['views']['Form']['Dialog']['preview']['form4_instruction']
                          }}
                        </p>
                      </ShadowBox>
                    </div>
                  </div>
                </div>

                <div class="px-4 py-2">
                  <button class="w-full button bg-blue-light">{{lang['views']['Form']['Dialog']['preview']['next']}}</button>
                </div>
              </div>
            </ShadowBox>
          </div>

          <ShadowBox
            v-show="hint"
            class="absolute mb-4 right-4 bottom-0 w-96 z-50"
            shadow="xl border border-gray-200"
          >
            <button
              @click="hint = false"
              class="
                p-dialog-header-icon p-dialog-header-close p-link
                -mt-2
                -mr-4
                mb-2
                ml-auto
              "
              aria-label="close"
              type="button"
              tabindex="-1"
            >
              <span class="p-dialog-header-close-icon pi pi-times"></span>
            </button>

            <div class="flex">
              <div class="flex-none">
                <img class="-ml-2 mr-2 w-6" src="../assets/light.png" />
              </div>
              <p class="flex-grow text-justify">
                {{lang['views']['Form']['Dialog']['block_info']}}
              </p>
            </div>
          </ShadowBox>
        </div>
      </template>

      <template content="" v-slot:footer>
        <div class="text-right">
          <button class="button bg-yellow" style="margin-right:36px;" @click="form_update()">{{lang['views']['Form']['Dialog']['save_button']}}</button>
        </div>
      </template>
    </ModifyWindows>
     <!-- 新手教學 -->
    <Mask :isDisplay="formGuideStep > -1" />
    <FormGuideTips
      v-show="formGuideStep >= 801"
      :nowStep="formGuideStep"
      @nextStep="nextStep"
      @closeTips="closeTips"
    />
  </div>
</template>
<script>
import { ref } from 'vue'
// import Header from "@/components/Header.vue";
// <!-- 新手教學 -->
import Mask from '@/components/Event/Mask.vue';
import FormGuideTips from '@/components/Tips/FormGuideTips.vue';
// <!-- 新手教學 -->
import ShadowBox from "@/components/ShadowBox.vue";
import ModifyWindows from "@/components/ModifyWindows.vue";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import InputSwitch from "primevue/inputswitch";
import CascadeSelect from "primevue/cascadeselect";
import FormInput from "@/components/Form/Input.vue";
import FormTextarea from "@/components/Form/Textarea.vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import draggable from "vuedraggable";
import axios from 'axios'
import Qs from 'qs'

const formName = ref('');

export default {
  name: "Form",
  components: {
    // <!-- 新手教學 -->
    Mask,
    FormGuideTips,
    // <!-- 新手教學 -->
    // Header,
    ShadowBox,
    ModifyWindows,
    Checkbox,
    RadioButton,
    Dropdown,
    InputSwitch,
    CascadeSelect,
    draggable,
    FormInput,
    FormTextarea,
    Swal,
    Loading,
  },
  props: {
    // <!-- 新手教學 -->
    guideStep: {
      type: Number,
      default: -1
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    pageId: {
      type:String
    },
    goalsObjective:{
      type:String
    },
    formId: {
      type:String
    },
    firstFormId: {
      type:String
    },
    formStatus: {
      type:String
    },
    useTeachDetail: {
      type: Boolean
    },
    targetAllSkip:{
      type: Number
    },
    formTeachingOver: {
      type: Boolean
    },
    teachingId: {
      type: Number,
      default: -1
    },
    selectLang: {
      type:String,
      default: 'zh-TW'
    },
    campaignId: {
      type: Number,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {
      // <!-- 新手教學 -->
      formTeaching_id: 0,
      formTeachingOverData: 0,
      formGuideStep: -1,
      formGuide: true,
      // <!-- 新手教學 -->
      showFormList: false,
      showModal: false,
      hint: false,
      preview: 1,
      previewTitle: "",
      selectedItem: null,
      immediateList: [],
      editType: 0,
      form3Options:[
                { name: '單選題', code: '01', type: 'CUSTOM' },
                { name: '簡答題', code: '02', type: 'CUSTOM' },
                { name: '安排預約時間', code: '03', type: 'DATE_TIME' }
              ],
      countryCodeListBase:[
        { name: '阿根廷（+54）', code: 'AR' },
        { name: '澳大利亞（+61）', code: 'AU' },
        { name: '巴西（+55）', code: 'BR' },
        { name: '中國（+86）', code: 'CN' },
        { name: '哥倫比亞（+57）', code: 'CO' },
        { name: '英國（+44）', code: 'GB' },
        { name: '香港（+852）', code: 'HK' },
        { name: '日本（+81）', code: 'JP' },
        { name: '南韓（+82）', code: 'KR' },
        { name: '澳門（+853）', code: 'MO' },
        { name: '墨西哥（+52）', code: 'MX' },
        { name: '馬來西亞（+60）', code: 'MY' },
        { name: '奈及利亞（+234）', code: 'NG' },
        { name: '菲律賓（+63）', code: 'PH' },
        { name: '新加坡（+65）', code: 'SG' },
        { name: '薩爾瓦多（+503）', code: 'SV' },
        { name: '泰國（+66）', code: 'TH' },
        { name: '台灣（+886）', code: 'TW' },
        { name: '美國（+1）', code: 'US' },
        { name: '越南（+84）', code: 'VN' },
        { name: '南非（+27）', code: 'ZA' },
      ],
      // immediateList: [
      //   {
      //     checked: false,
      //     title: "選項一",
      //     status: "formal",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: true,
      //     title: "選項二",
      //     status: "draft",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項三",
      //     status: "error",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項四",
      //     status: "formal",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項五",
      //     status: "draft",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項六",
      //     status: "error",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項七",
      //     status: "formal",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項八",
      //     status: "draft",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項九",
      //     status: "error",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項十",
      //     status: "formal",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項十一",
      //     status: "draft",
      //     date: "2021-05-20"
      //   },
      //   {
      //     checked: false,
      //     title: "選項十二",
      //     status: "error",
      //     date: "2021-05-20"
      //   }
      // ],
      menuActive: 1,
      formData: {
        form1: {
          type: "0"
        },
        form2: {
          isOpen: false,
          title: "",
          introductionType: "0",
          introduction: "",
          introductionItem: ["", "", "", "", ""]
        },
        form3: {
          type: "",
          single: [],
          other: []
        },
        form4: {
          type: "",
          instruction: "",
          isOpenInstruction: false,
          isCountries: [],
          countries: [],
          dataType: []
        },
        form5: {
          isOpen: false,
          url: "",
          urlText: "",
          content: "",
          agree: []
        },
        from6: {},
        form7: {
          title: "",
          main: "",
          web: "",
          countryCode:{ name: '台灣（+886）', code: 'TW' },
          business_phone_number: "",
          btntext: "",
          url: ""
        },
        form8: {
          lang: "",
          shareType: "0"
        },
        focus: ""
      }
    };
  },
  watch:{
    'lang':function(v){
      this.previewTitle = this.lang['views']['Form']['Dialog']['data']['previewTitle'];

      this.form3Options = [
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_01'], code: '01', type: 'CUSTOM' },
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_02'], code: '02', type: 'CUSTOM' },
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_03'], code: '03', type: 'DATE_TIME' }
                          ];

      this.countryCodeListBase = [
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['AR'], code: 'AR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['AU'], code: 'AU' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['BR'], code: 'BR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['CN'], code: 'CN' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['CO'], code: 'CO' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['GB'], code: 'GB' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['HK'], code: 'HK' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['JP'], code: 'JP' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['KR'], code: 'KR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MO'], code: 'MO' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MX'], code: 'MX' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MY'], code: 'MY' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['NG'], code: 'NG' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['PH'], code: 'PH' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['SG'], code: 'SG' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['SV'], code: 'SV' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TH'], code: 'TH' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TW'], code: 'TW' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['US'], code: 'US' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['VN'], code: 'VN' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['ZA'], code: 'ZA' },
      ];

      this.formData.form7.countryCode = { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TW'], code: 'TW' };
    },
    formTeachingOver(value){
      //console.log('b formTeachingOverData');
      //console.log(value);
      //console.log(this.formTeachingOverData);

      if(value != '' && value != null && typeof value != 'undefined'){
        let get_value = value.split('_');

        //console.log(get_value);

        this.formTeachingOverData = parseInt(get_value[0])
      }

      //console.log('a formTeachingOverData');
      //console.log(this.formTeachingOverData);
    },
    viewDatalist(v){
      // console.log('form viewDatalist');
      // console.log(v);
    },
    pageId(v){
      // console.log('form pageId');
      // console.log(v);

      axios
        .post('https://www.autoturn.net/api/campaign_form_leadgen_forms.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: v
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.immediateList = response.data.return_data
          }
        });
    },
    formId(v){
      // console.log('formId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);


      if(v != '' && v != null && typeof v != 'undefined'){
        let get_value = v.split('_');

        // console.log(get_value);

        this.selectedItem = parseInt(get_value[0])
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    firstFormId(v){
      // console.log('firstFormId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);

      if(v != '' && v != null && typeof v != 'undefined'){
        this.selectedItem = v
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    // <!-- 新手教學 -->
    formStatus(v){
      // console.log('formStatus');
      // console.log(v);
      this.editType = 2
      if(v == 'Y'){
        this.editType = 1
      }
    },
    showModal(val) {
      if (!val) {
        this.formGuideStep = -1;
        this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
      } else {
        this.form3Options = [
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_01'], code: '01', type: 'CUSTOM' },
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_02'], code: '02', type: 'CUSTOM' },
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_03'], code: '03', type: 'DATE_TIME' }
                            ];

        if (this.$route.query.formguide) {
          this.formGuide = this.$route.query.formguide === 'false' ? false : true;
          this.formGuideStep = this.$route.query.formguide === 'false' ? -1 : 701;
          this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
        }
      }

    },
    formGuideStep(val) {
      if (val === 805) {
        this.menuActive = 2;
        this.formData.form2.isOpen = true;
        this.$refs.introContent.scrollTo({
          top: 50,
          behavior: 'smooth'
        });
      } else if (val === 808) {
        this.menuActive = 3;
        this.$refs.introContent.scrollTo({
          top: 80,
          behavior: 'smooth'
        });
      } else if (val === 810) {
        this.formData.form3.single.push({
          id: this.getMaxId(this.formData.form3.single),
          type: this.formData.form3.type,
          text: "",
          answer: [{ text: this.lang['views']['Form']['Dialog']['watch']['formGuideStep']['form3_single_answer'] }],
          answerText: "",
          isOpen: true
        });
      } else if (val === 816) {
        this.menuActive = 4;
        this.$refs.introContent.scrollTo({
          top: 100,
          behavior: 'smooth'
        });
      } else if (val === 819) {
        this.menuActive = 5;
        this.$refs.introContent.scrollTo({
          top: 120,
          behavior: 'smooth'
        });
      } else if (val === 820) {
        this.menuActive = 6;
        this.$refs.introContent.scrollTo({
          top: 130,
          behavior: 'smooth'
        });
      } else if (val === 821) {
        this.menuActive = 7;
        this.$refs.introContent.scrollTo({
          top: 140,
          behavior: 'smooth'
        });
      } else if (val === 822) {
        this.menuActive = 8;
        this.$refs.introContent.scrollTo({
          top: 150,
          behavior: 'smooth'
        });
      }
    }
    // <!-- 新手教學 -->
  },
  mounted() {
    if (this.$route.query.formguide) {
      this.formGuide = this.$route.query.formguide === 'false' ? false : true;
    }
  },
  created() {
    // console.log('this.route.params.id');
    // console.log(this.$route.params.id);
    if(this.pageId != '' && this.pageId != null && typeof this.pageId != 'undefined'){
      axios
        .post('https://www.autoturn.net/api/campaign_form_leadgen_forms.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.immediateList = response.data.return_data
          }
        });
    }
  },
  methods: {
    // <!-- 新手教學 -->
    nextStep() {
      if (this.formGuideStep === 823) {
        axios
          .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: this.formTeaching_id,
            campaign_id: this.campaignId,
            campaign_objective: this.goalsObjective,
            skip: 1,
            step: this.formGuideStep,
            active: ''
          }))
          .then((response) => {
            if(response.data.teaching_status == 'Y'){
              this.formTeaching_id = 0;
              this.formTeachingOverData = 1;
              this.$emit('childFormTeachingOver', 1);
            }
            this.formGuideStep = -1;
            this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
          });
      } else {
        axios
          .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            id: this.formTeaching_id,
            campaign_id: this.campaignId,
            campaign_objective: this.goalsObjective,
            skip: 0,
            step: this.formGuideStep,
            active: ''
          }))
          .then((response) => {
            this.formGuideStep = this.formGuideStep + 1;
            this.$router.push({ query: { step: this.formGuideStep }});
          });
      }
    },
    closeTips() {
      //console.log('closeTips');
      //console.log(this.formGuideStep);

      let skip = 0;
      let skip_target = [801, 823];
      for(let i = 0; i < skip_target.length; i++){
        if(this.formGuideStep == skip_target[i]){
          skip = 1;
        }
      }
      // if(this.nowStep == 70){
      //   skip = 1;
      // }

      axios
        .post('https://www.autoturn.net/api/data/teaching_update.php', Qs.stringify({
          s_code: this.$route.params.id,
          id: this.formTeaching_id,
          campaign_id: this.campaignId,
          campaign_objective: this.goalsObjective,
          skip: skip,
          step: this.formGuideStep,
          active: ''
        }))
        .then((response) => {
          if(response.data.teaching_status == 'Y'){
            this.formTeaching_id = 0;
            this.formTeachingOverData = 1;
            this.$emit('childFormTeachingOver', 1);
          }

          this.formGuideStep = -1;
          this.$router.push({ query: { step: this.formGuideStep }});
        });
    },
    // <!-- 新手教學 -->
    newForm(){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.formName = '';
        this.formData = {
          form1: {
            type: "0"
          },
          form2: {
            isOpen: false,
            title: "",
            introductionType: "0",
            introduction: "",
            introductionItem: ["", "", "", "", ""]
          },
          form3: {
            type: "",
            single: [],
            other: []
          },
          form4: {
            type: "",
            instruction: "",
            isOpenInstruction: false,
            isCountries: [],
            countries: [
              {
                name: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                code: "01",
                sub: [
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_email'],
                    code: "EMAIL"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_phone_number'],
                    code: "PHONE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_street_address'],
                    code: "STREET_ADDRESS"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_city'],
                    code: "CITY"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_state'],
                    code: "STATE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_province'],
                    code: "PROVINCE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_country'],
                    code: "COUNTRY"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_post_code'],
                    code: "POST_CODE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_zip_code'],
                    code: "ZIP"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['member_name'],
                code: "02",
                sub: [
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_full_name'],
                    code: "FULL_NAME"
                  },
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_first_name'],
                    code: "FIRST_NAME"
                  },
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_last_name'],
                    code: "LAST_NAME"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                code: "03",
                sub: [
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_date_of_birth'],
                    code: "DOB"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_gender'],
                    code: "GENDER"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_marital_status'],
                    code: "MARITIAL_STATUS"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_relationship_status'],
                    code: "RELATIONSHIP_STATUS"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_military_status'],
                    code: "MILITARY_STATUS"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['work_name'],
                code: "04",
                sub: [
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_job_title'],
                    code: "JOB_TITLE"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_work_phone_number'],
                    code: "WORK_PHONE_NUMBER"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_work_email'],
                    code: "WORK_EMAIL"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_company_name'],
                    code: "COMPANY_NAME"
                  }
                ]
              }
            ],
            dataType: []
          },
          form5: {
            isOpen: false,
            url: "",
            urlText: "",
            content: "",
            agree: []
          },
          from6: {},
          form7: {
            title: "",
            main: "",
            web: "",
            countryCode:{ name: '台灣（+886）', code: 'TW' },
            business_phone_number: "",
            btntext: "",
            url: ""
          },
          form8: {
            lang: "",
            shareType: "0"
          },
          focus: ""
        };

        this.showModal = true;
        // <!-- 新手教學 -->
        //console.log('this.formTeachingOverData');
        //console.log(this.formTeachingOverData);
        if(this.useTeachDetail == true && this.formTeachingOverData == 0 && this.targetAllSkip == 0){
          axios
            .post('https://www.autoturn.net/api/data/teaching_create.php', Qs.stringify({
              s_code: this.$route.params.id,
              step: 801
            }))
            .then((response) => {
              this.formTeaching_id = response.data.id;
              this.formGuideStep = 801;
              this.$router.push({ query: { step: this.formGuideStep }});
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Form']['Dialog']['methods']['newForm']['not_pageId_swal_title'],
                  this.lang['views']['Form']['Dialog']['methods']['newForm']['not_pageId_swal_text'],
                  'error'
                )
      }
      // <!-- 新手教學 -->
    },
    changeSelectItem(value){
      this.selectedItem = value;
      //console.log('changeSelectItem');
      //console.log(value);
      // this.$emit('childChangeFormId', null);
      // console.log('1');
      // this.$emit('update:testFormId', value);
      // console.log('2');
      // this.$emit('testFormId', value);
      // console.log('3-1');
      // this.$emit('childChangeFormId', 1);

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
      //console.log('3-2');
      this.$emit('childChangeFormId', get_value);
      //console.log('4');
      this.$emit('childAdIsChangeData', true);
      for (let i = 0; i < this.immediateList.length; i++) {
        if (this.immediateList[i].id === value) {
          if(this.immediateList[i].status == 'formal'){
            // console.log('正式');
            this.editType = 1
          } else {
            // console.log('草稿');
            this.editType = 2
          }
        }
      }
    },
    activeImmediate(value, type){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        if(value != ''){
          axios
            .post('https://www.autoturn.net/api/campaign_form_leadgen_forms_view.php', Qs.stringify({
              s_code: this.$route.params.id,
              id: value,
              type: type
            }))
            .then((response) => {
              // console.log(response.data.return_data.form);
              if(response.data.status == 'success'){
                // this.immediateList = response.data.return_data
                this.formData = response.data.return_data.form

                if(type == 1){
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.formName = 'title_'+todayForm;
                } else {
                  this.formName = response.data.return_data.name;
                }

                this.showModal = true
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Form']['Dialog']['methods']['activeImmediate']['not_pageId_swal_title'],
                  this.lang['views']['Form']['Dialog']['methods']['activeImmediate']['not_pageId_swal_text'],
                  'error'
                )
      }
    },
    prev() {
      if (this.preview > 1) this.preview--;
    },
    next() {
      if (this.preview < 4) this.preview++;
    },
    getMaxId(list) {
      let id = 1;
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (id < list[i].id) {
            id = list[i].id;
          }
        }

        id += 1;
      }

      return id;
    },
    form3TypeChange() {
      // if(this.editPageType == false){
        if (this.formData.form3.type.code == "01") {
          this.formData.form3.single.push({
            id: this.getMaxId(this.formData.form3.single),
            type: this.formData.form3.type,
            text: "",
            answer: [],
            answerText: "",
            isOpen: false
          });
        } else {
          let otherLength = this.formData.form3.other.length
          let haveDate = 0;
          if(otherLength > 0){
            for(let i = 0; i < otherLength; i++){
              if(this.formData.form3.other[i].type.code == "03"){
                haveDate = 1;
              }
            }
          }

          // console.log("haveDate");
          // console.log(haveDate);
          // console.log("this.formData.form3.type");
          // console.log(this.formData.form3.type);

          if(haveDate == 0){
            this.formData.form3.other.push({
              id: this.getMaxId(this.formData.form3.other),
              type: this.formData.form3.type,
              text: "",
              confirm: "",
              isOpen: false
            });
          } else {
            if(this.formData.form3.type.code != "03"){
              this.formData.form3.other.push({
                id: this.getMaxId(this.formData.form3.other),
                type: this.formData.form3.type,
                text: "",
                confirm: "",
                isOpen: false
              });
            }
          }
        }

        // console.log('single');
        // console.log(this.formData.form3.single);
        // console.log('other');
        // console.log(this.formData.form3.other);
        // console.log('b type');
        // console.log(this.formData.form3.type);

        this.formData.form3.type = "";

        // console.log('a type');
        // console.log(this.formData.form3.type);
      // }
    },
    getForm3Other(id) {
      return (
        this.formData.form3.other.filter(x => x.type.code == id).length > 0
      );
    },
    setForm3Answer(obj) {
      // if(this.editPageType == false){
        if (obj) {
          obj.answer.push({ text: obj.answerText });
        }
        obj.answerText = "";
      // }
    },
    removeForm3Single(id) {
      // console.log('b removeForm3Single');
      // console.log(id);
      // console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.single.length; i++) {
          if (this.formData.form3.single[i].id == id) {
            this.formData.form3.single.splice(i, 1);
            break;
          }
        }
      // }

      // console.log('a removeForm3Single');
      // console.log(this.formData.form3);
    },
    removeForm3SingleAnswer(id, index) {
      // console.log('b removeForm3SingleAnswer');
      // console.log(id+':'+ index);
      // console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.single.length; i++) {
          if (this.formData.form3.single[i].id == id) {
            this.formData.form3.single[i].answer.splice(index, 1);
            break;
          }
        }
      // }

      // console.log('a removeForm3SingleAnswer');
      // console.log(this.formData.form3);
    },
    removeForm3Other(id) {
      // console.log('b removeForm3Other');
      // console.log(id);
      // console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.other.length; i++) {
          if (this.formData.form3.other[i].id == id) {
            this.formData.form3.other.splice(i, 1);
            break;
          }
        }
      // }

      // console.log('a removeForm3Other');
      // console.log(this.formData.form3);
    },
    form4TypeChange() {
      // if(this.editPageType == false){
        if (
          this.formData.form4.isCountries.indexOf(
            this.formData.form4.type.code
          ) == -1
        ) {
          this.formData.form4.dataType.push({
            type: this.formData.form4.type,
            text: this.formData.form4.type.name
          });
          this.formData.form4.isCountries.push(this.formData.form4.type.code);
        }

        // console.log(this.formData.form4.isCountries);
        // console.log(this.formData.form4.type);
        // console.log(this.formData.form4.dataType);

        this.formData.form4.type = "";
      // }
    },
    removeForm4Datatype(code) {
      // if(this.editPageType == false){
        if (this.formData.form4.isCountries.indexOf(code) > -1) {
          this.formData.form4.isCountries.splice(
            this.formData.form4.isCountries.indexOf(code),
            1
          );
        }

        for (let i = 0; i < this.formData.form4.dataType.length; i++) {
          if (this.formData.form4.dataType[i].type.code == code) {
            this.formData.form4.dataType.splice(i, 1);
            break;
          }
        }
      // }
    },
    setForm5Agree() {
      // if(this.editPageType == false){
        this.formData.form5.agree.push({ content: "", isAgree: false });
      // }

      // console.log('setForm5Agree');
      // console.log(this.formData.form5.agree);
    },
    test(){
      // console.log(this.formData.form8.lang);
    },
    IsURL(str_url){
      //console.log('str_url');
      //console.log(str_url);
      // var strRegex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      // var strRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      // var strRegex = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
      // var re = new RegExp(strRegex);
      // //re.test()
      // if (re.test(str_url)){
        //console.log('#1');
        return true;
      // } else {
      //   //console.log('#2');
      //   return false;
      // }
    },
    form_update(){
      // console.log('this.formTitle');
      // console.log(this.formTitle);
      // console.log('this.formData');
      // console.log(this.formData);

      // console.log('this.formName');
      // console.log(this.formName);

      let title = this.formName
      let data = this.formData

      // if(this.editPageType == false){
        let isTrue = 1;
        let swal_title = '';
        let swal_info = '';

        let form7_url = data.form7.url
        if(this.IsURL(form7_url) == false){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['url_format_error_swal_text'];
        }

        if(data.form7.url == '' || data.form7.url == null || data.form7.url == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_url_swal_text'];
        }

        if(data.form7.web.code == 'CALL_BUSINESS'){
          if(data.form7.business_phone_number == '' || data.form7.business_phone_number == null || data.form7.business_phone_number == 'undefined'){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_phone_swal_text'];
          }          
        }

        if(data.form7.btntext == '' || data.form7.btntext == null || data.form7.btntext == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_btntext_swal_text'];
        }

        if(data.form7.main == '' || data.form7.main == null || data.form7.main == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_main_swal_text'];
        }

        if(data.form7.title == '' || data.form7.title == null || data.form7.title == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_title_swal_text'];
        }

        let form5Agree = data.form5.agree.length;
        for(let i = 0; i < form5Agree; i++){
          let agree_content = data.form5.agree[i].content;
          if(data.form5.isOpen == true && (agree_content?.trim() == '' || agree_content?.trim() == null || agree_content?.trim() == 'undefined')){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_agree_content_swal_text'];
          }
        }

        let form5_content = data.form5.content;
        if(data.form5.isOpen == true && (form5_content?.trim() == '' || form5_content?.trim() == null || form5_content?.trim() == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_content_swal_text'];
        }

        let form5_title = data.form5.title;
        if(data.form5.isOpen == true && (form5_title?.trim() == '' || form5_title?.trim() == null || form5_title?.trim() == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_title_swal_text'];
        }

        let form5_urlText = data.form5.urlText;
        //console.log('form5_urlText');
        //console.log(form5_urlText);
        if(form5_urlText != '' && form5_urlText != null && form5_urlText != 'undefined'){
          //console.log('form5_urlText in');
          if(form5_urlText.length > 70){
            //console.log('form5_urlText error');
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['urlText_error_swal_text'];
          }
        }

        let form5_url = data.form5.url?.trim()
        if(this.IsURL(form5_url) == false){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['url_format_error_swal_text'];
        }

        if(form5_url == '' || form5_url == null || form5_url == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_url_swal_text'];
        }

        let form4_instruction = data.form4.instruction;
        if(form4_instruction?.trim() == '' || form4_instruction?.trim() == null || form4_instruction?.trim() == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form4']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form4']['swal_text'];
        }

        let form3Other = data.form3.other.length;
        let form3Single = data.form3.single.length;
        if(form3Single > 0){
          for(let i = 0; i < form3Single; i++){
            if(data.form3.single[i].type.code == '01'){
              let answerLength = data.form3.single[i].answer.length;
              if(answerLength > 0){
                if(answerLength == 1){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['answerLength_number_of_items_swal_text'];
                } else {
                  for(let j = 0; j < answerLength; j++){
                    if(data.form3.single[i].answer[j].text == '' || data.form3.single[i].answer[j].text == null || data.form3.single[i].answer[j].text == 'undefined'){
                      isTrue = 0;
                      swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                      swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['answerLength_not_text_swal_text'];
                    }
                  }
                }
              } else {
                isTrue = 0;
                swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['not_answerLength_swal_text'];
              }

              if(data.form3.single[i].text == '' || data.form3.single[i].text == null || data.form3.single[i].text == 'undefined'){
                isTrue = 0;
                swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['not_text_swal_text'];
              }
            }
          }
        }

        if(form3Other > 0){
            for(let i = 0; i < form3Other; i++){
              if(data.form3.other[i].type.code == '02'){
                if(data.form3.other[i].text == '' || data.form3.other[i].text == null || data.form3.other[i].text == 'undefined'){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['code_02_not_text_swal_text'];
                }
              }

              if(data.form3.other[i].type.code == '03'){
                if(data.form3.other[i].text == '' || data.form3.other[i].text == null || data.form3.other[i].text == 'undefined'){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['code_03_not_text_swal_text'];
                }
              }
            }
        }

        if(data.form2.isOpen == true && data.form2.introductionType == '1'){
          let introductionItemLength = data.form2.introductionItem.length;
          let itemTrue = 0;
          for(let i = 0; i < introductionItemLength; i++){
            let introductionItem = data.form2.introductionItem[i].trim();
            if(introductionItem != '' && introductionItem != null && typeof introductionItem != 'undefined'){
              // console.log('itemTrue');
              itemTrue = 1;
              break;
            }
          }

          for(let j = 0; j < introductionItemLength; j++){
            let introductionItemContent = data.form2.introductionItem[j].replace(/[^\x00-\xff]/g,"OO").length;
            if(introductionItemContent > 80){
              itemTrue = 2;
            }
          }

          if(itemTrue == 0){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_itemTrue_swal_text'];
          }

          if(itemTrue == 2){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['under_80_characters_itemTrue_swal_text'];
          }
        }

        if(data.form2.isOpen == true && data.form2.introductionType == '0' && (data.form2.introduction == '' || data.form2.introduction == null || data.form2.introduction == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_introductionType_swal_text'];
        }

        if(data.form2.isOpen == true && (data.form2.title == '' || data.form2.title == null || data.form2.title == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_title_swal_text'];
        }

        if(title == '' || title == null || title == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['formTitle_swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['formTitle_swal_text'];
        }

        if(isTrue == 0){
          Swal.fire(
                    swal_title,
                    swal_info,
                    "warning"
                  )
        } else {
          axios
            .post('https://www.autoturn.net/api/data/form_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              form_title: title,
              form_data: data,
            }))
            .then((response) => {
              // console.log(response.data);
              // if(response.data.status == 'success'){
                // this.immediateList = response.data.return_data
                // this.formData = response.data.return_data.form

                // if(type == 1){
                //   var todayForm = new Date();
                //   var yearForm = todayForm.getFullYear();
                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                //   this.formTitle = 'title_'+todayForm;
                // } else {
                //   this.formTitle = response.data.return_data.name;
                // }

                // this.showModal = true
              // }
              if(response.data.status == 'login'){
                Swal.fire({
                  icon: 'error',
                  title: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['swal_title'],
                  text: response.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    // this.allPageLoading = true
                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    // this.allPageLoading = true
                    window.location.href = "https://www.autoturn.net/index.php/index/logout/"+this.$route.params.id+"?o=1";
                  }
                })
              } else {
                Swal.fire({
                  icon: response.data.status,
                  title: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['swal_title'],
                  text: response.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['confirm_button'],
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    this.showFormList = true;
                    this.showModal = false
                    // Swal.fire('Saved!', '', 'success')
                    axios
                      .post('https://www.autoturn.net/api/campaign_form_leadgen_forms.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        page_id: this.pageId
                      }))
                      .then((response) => {
                        if(response.data.status == 'success'){
                          this.immediateList = response.data.return_data
                        }

                        this.showFormList = false
                      });
                  } else if (result.isDenied) {
                    this.showFormList = true;
                    // Swal.fire('Changes are not saved', '', 'info')
                    axios
                      .post('https://www.autoturn.net/api/campaign_form_leadgen_forms.php', Qs.stringify({
                        s_code: this.$route.params.id,
                        page_id: this.pageId
                      }))
                      .then((response) => {
                        if(response.data.status == 'success'){
                          this.immediateList = response.data.return_data
                        }

                        this.showFormList = false
                      });
                  }
                })
              }
            });
        }
      // }
    }
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    }
  },
};
</script>
